export const CENTRIFUGE_CHANNELS = {
  COMMON: "common",
  AI_SAMPLE: "ai_sample",
} as const;

export const PERSONAL_CHANNEL_PREFIX = {
  COMMON: "common:user#",
  AI_SAMPLE: "ai_sample:user#",
} as const;
